import React, { Suspense } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import ErrorFallback from '../common/ErrorFallback'
import { LoaderProvider } from '../context/FormLoader'
import CreateFeedbackMain from './CreateFeedbackMain'
import FeedbackBreadcrumbs from './FeedbackBreadcrumbs'

const FeedbackLanding = () => {
  return (
    <Suspense fallback={null}>
      <LoaderProvider>
        <div className="content-wrapper landing one-column">
          <FeedbackBreadcrumbs />
          <ErrorBoundary FallbackComponent={ErrorFallback}>
            <CreateFeedbackMain />
          </ErrorBoundary>
        </div>
      </LoaderProvider>
    </Suspense>
  )
}

export default FeedbackLanding
